import axios from '../axios'
// 心得列表
export const getNoteList = (data) => {
  return axios({
    url: '/con/manage/note/list',
    method: 'POST',
    data: data
  })
}
// 心得详情
export const getDetailList = (data) => {
  return axios({
    url: '/con/manage/note/detail/list',
    method: 'POST',
    data: data
  })
}
// 心得详情
export const getDetail = (data) => {
  return axios({
    url: '/con/manage/note/detail/get',
    method: 'POST',
    data: data
  })
}
// 删除心得
export const postDeleteNote = (data) => {
  return axios({
    url: '/con/manage/note/detail/delete',
    method: 'POST',
    data: data
  })
}
// 切图列表
export const getImgList = (data) => {
  return axios({
    url: '/con/manage/image/list',
    method: 'POST',
    data
  })
}
// 新增 
export const addImage = (data) => {
  return axios({
    url: '/con/manage/image/save',
    method: 'POST',
    data
  })
}
// 删除 
export const postDeletrImage = (data) => {
  return axios({
    url: '/con/manage/image/delete',
    method: 'POST',
    data
  })
}
//获取文学圈列表
export const circleList = (data) => {
  return axios({
    url: '/con/literary/circle/list',
    method: 'GET',
    data
  })
}
// 文学圈详情
export const circleDetail = (data) => {
  return axios({
    url: `/con/literary/circle/detail`,
    method: 'GET', 
    data   
  })
}
export const deleteCircle = (data) => {
  return axios({
    url: `/con/literary/circle/delete`,
    method: 'POST', 
    data   
  })
}






// WEBPACK FOOTER //
// ./src/http/moudules/experienceManagement.js